import React from "react";
import { Navigate } from "react-router-dom";

export default function Sample() {
  return <Navigate to="/c/demo" replace />;
}
